module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av453-cead0246325318b58293fe154ec9cc57.jpg";